export default class SocialMediaWall {
    static init()
    {
        const walls = document.querySelectorAll('.social-media-wall');
        walls.forEach(el => {
            new SocialMediaWall(el);
        })
    }

    constructor(el)
    {
        this.element = el;
        const contentElement = this.element.querySelector('.social-media-wall__content');
        if (contentElement) {
            this.loadScript(contentElement);
        }
        // It can happen, that a user revokes and re-applies the consent, thus we need to observe if the content element comes back
        this.onCookieConsentAccepted((contentElement) => {
            this.loadScript(contentElement);
        });
    }

    onCookieConsentAccepted(callback)
    {
        let config = { attributes: false, childList: true, subtree: true };
        let mutationObserverCallback = (mutationsList) => {
            for(let mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach((node) => {
                        if(node.nodeType === Node.ELEMENT_NODE) {
                            if(node.classList.contains('social-media-wall__content')) {
                                callback(node);
                            }
                        }
                    });
                }
            }
        };
        let observer = new MutationObserver(mutationObserverCallback);
        observer.observe(this.element, config);
    }

    loadScript(contentElement)
    {
        let tag = document.createElement('script');
        tag.src = 'https://walls.io/js/wallsio-widget-1.2.js';
        tag.async = true;
        tag.dataset.width = '100%';
        tag.dataset.wallurl = contentElement.dataset.wallurl;
        tag.dataset.autoheight = '1'
        tag.dataset.height = '0'
        tag.dataset.lazyload = '1'
        contentElement.innerHTML = '';
        contentElement.appendChild(tag);
    }
}
